import dayjs from "dayjs";
import { ShipmentDetails } from "../../../../hooks/react-query/outbound/freightDetails/useGetShipmentDetails";

export const shipmentDetails = {
  default: {
    summary: {
      bills: 2,
      loadedBills: 2,
      weight: 200,
      loadedWeight: 200,
      pieces: 0,
      handlingUnits: 0,
      pallets: 2,
      tonnageByFinalDestination: [
        {
          sicId: 111,
          sic: "ONT",
          weight: 100,
          color: "#B0BEC5",
          bills: 1,
          handlingUnits: 0,
          pallets: 1,
          pieces: 0,
        },
        {
          sicId: 1,
          sic: "EWR",
          weight: 100,
          color: "#78909C",
          bills: 1,
          pallets: 1,
          pieces: 0,
          handlingUnits: 0,
        },
        {
          sicId: 1,
          sic: "ATM",
          weight: 100,
          color: "#78909C",
          bills: 1,
          pallets: 1,
          pieces: 0,
          handlingUnits: 0,
        },
      ],
      indicators: {
        unassignedBillsCount: 1,
        missServiceBillsCount: 2,
        noTrailersBillsCount: 3,
        noTripsBillsCount: 3,
        noDoorBillsCount: 2,
      },
    },
    shipments: [
      {
        shipmentId: 1234,
        proNumber: "P1234",
        doorNumber: 1,
        originSic: "DAL",
        loadToSic: "ONT",
        originalLane: "ONT",
        laneType: "Regular",
        destinationSic: "ONT",
        trailerNumber: "DAL-1234",
        tripNumber: 891027,
        serviceDue: dayjs("2024-09-26T00:00:00"),
        pickUpDate: dayjs("2024-09-25"),
        pieces: 0,
        pallets: 1,
        handlingUnits: 0,
        weight: 100,
        willMakeService: true,
        isUnassigned: true,
        status: "ARRV",
        tags: [
          {
            id: 1,
            name: "APTR",
            color: "#123456",
          },
        ],
        currentLocation: {
          type: "Trip",
          name: "891028",
          trailer: "DAL-789",
          tripNumber: 891028,
          pullId: null,
          trapId: null,
        },
      },
      {
        shipmentId: 12987473,
        proNumber: "P12987473",
        doorNumber: 1,
        originSic: "DAL",
        loadToSic: "LAX",
        originalLane: "ONT",
        laneType: "Regular",
        destinationSic: "LAX",
        trailerNumber: "DAL-3452",
        tripNumber: 891029,
        serviceDue: dayjs("2024-09-27T00:00:00"),
        pickUpDate: dayjs("2024-09-24"),
        pieces: 0,
        handlingUnits: 0,
        pallets: 2,
        weight: 300,
        willMakeService: false,
        isUnassigned: true,
        status: "ARRV",
        tags: [
          {
            id: 1,
            name: "VC",
            color: "#aa7ea0",
          },
        ],
        currentLocation: {
          type: "Trap",
          name: "123",
          trailer: "DAL-3452",
          tripNumber: null,
          pullId: null,
          trapId: 123,
        },
      },
      {
        shipmentId: 132813622,
        proNumber: "162987440",
        doorNumber: null,
        originSic: "ONT",
        loadToSic: "ATM",
        originalLane: "ONT",
        laneType: "Regular",
        destinationSic: "ATM",
        trailerNumber: "",
        tripNumber: null,
        serviceDue: dayjs("2024-11-11T18:55:00"),
        pickUpDate: dayjs("2024-11-10"),
        pieces: 6,
        handlingUnits: 6,
        pallets: 1,
        weight: 296,
        willMakeService: true,
        isUnassigned: false,
        status: "ENRT",
        tags: [
          {
            id: 81,
            name: "VC",
            color: "#AA7EA0",
          },
        ],
        currentLocation: {
          type: "Route",
          name: "DAL-123",
          trailer: "Trailer",
          tripNumber: 9870,
          pullId: null,
          trapId: null,
        },
      },
      {
        shipmentId: 132813626,
        proNumber: "162987473",
        doorNumber: null,
        originSic: "ONT",
        loadToSic: "ATM",
        originalLane: "ONT",
        laneType: "Regular",
        destinationSic: "ATM",
        trailerNumber: "",
        tripNumber: null,
        serviceDue: dayjs("2024-11-11T18:55:00"),
        pickUpDate: dayjs("2024-11-10"),
        pieces: 11,
        handlingUnits: 11,
        pallets: 2,
        weight: 566,
        willMakeService: true,
        isUnassigned: false,
        status: "ENRT",
        tags: [
          {
            id: 81,
            name: "VC",
            color: "#AA7EA0",
          },
        ],
        currentLocation: {
          type: "OnDock",
          name: "On Dock",
          trailer: null,
          tripNumber: null,
          pullId: null,
          trapId: null,
        },
      },
      {
        shipmentId: 132813625,
        proNumber: "162987472",
        doorNumber: null,
        originSic: "ONT",
        loadToSic: "ATM",
        originalLane: "ONT",
        laneType: "Regular",
        destinationSic: "ATM",
        trailerNumber: "",
        tripNumber: null,
        serviceDue: dayjs("2024-11-12T18:55:00"),
        pickUpDate: dayjs("2024-11-11"),
        pieces: 11,
        handlingUnits: 11,
        pallets: 2,
        weight: 566,
        willMakeService: false,
        isUnassigned: false,
        status: "SPND",
        isLoaded: true,
        tags: [
          {
            id: 81,
            name: "VC",
            color: "#AA7EA0",
          },
        ],
        currentLocation: {
          type: "OnDock",
          name: "On Dock",
          trailer: null,
          tripNumber: null,
          pullId: null,
          trapId: null,
        },
      },
      {
        shipmentId: 132813627,
        proNumber: "162987474",
        doorNumber: null,
        originSic: "ONT",
        loadToSic: "ATM",
        originalLane: "ONT",
        laneType: "Regular",
        destinationSic: "ATM",
        trailerNumber: "",
        tripNumber: null,
        serviceDue: dayjs("2025-11-11T18:55:00"),
        pickUpDate: dayjs("2025-11-10"),
        pieces: 1,
        handlingUnits: 1,
        pallets: 1,
        weight: 150,
        willMakeService: true,
        isUnassigned: false,
        status: "LDDK",
        isLoaded: true,
        tags: [],
        currentLocation: {
          type: "Lane",
          name: "LAX",
          trailer: null,
          tripNumber: null,
          pullId: null,
          trapId: null,
        },
      },
      {
        shipmentId: 132813628,
        proNumber: "162987475",
        doorNumber: null,
        originSic: "ONT",
        loadToSic: "ATM",
        originalLane: "ONT",
        laneType: "Regular",
        destinationSic: "ATM",
        trailerNumber: "",
        tripNumber: 999999,
        serviceDue: dayjs("2025-11-11T18:55:00"),
        pickUpDate: dayjs("2025-11-10"),
        pieces: 2,
        handlingUnits: 2,
        pallets: 1,
        weight: 200,
        willMakeService: true,
        isUnassigned: false,
        status: "LDDK",
        isLoaded: true,
        tags: [],
        currentLocation: {
          type: "Trip",
          name: "Trip 999999",
          trailer: "TRAIL-999",
          tripNumber: 999999,
          pullId: 8888,
          trapId: null,
        },
      },
      {
        shipmentId: 132813629,
        proNumber: "162987476",
        doorNumber: null,
        originSic: "ONT",
        loadToSic: "ATM",
        originalLane: "ONT",
        laneType: "Regular",
        destinationSic: "ATM",
        trailerNumber: "",
        tripNumber: null,
        serviceDue: dayjs("2025-11-11T18:55:00"),
        pickUpDate: dayjs("2025-11-10"),
        pieces: 3,
        handlingUnits: 3,
        pallets: 1,
        weight: 300,
        willMakeService: true,
        isUnassigned: false,
        status: "CLOS",
        isLoaded: true,
        tags: [],
        currentLocation: {
          type: "OutboundTrip",
          name: "Trip 888",
          trailer: "TRAIL-888",
          tripNumber: null,
          pullId: 7777,
          trapId: null,
        },
      },
    ],
  },
} as const satisfies Record<string, ShipmentDetails>;
